import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../api";

const urlPrefix = "/api/v2/chatapp/quick-replies";

interface ICannedResponses {
  cannedResponses: Array<any>;
}

const initailState: ICannedResponses = {
  cannedResponses: []
};

const slice = createSlice({
  name: "cannedResponses",
  initialState: initailState,
  reducers: {
    cannedResponsesReceived: (state, action) => {
      state = { cannedResponses: action.payload.data };
      return state;
    }
  }
});

export const { cannedResponsesReceived } = slice.actions;

export const loadCannedResponses = (payload: any) => {
  return apiCallBegan({
    url: `${urlPrefix}?replyKey=${payload.key}`,
    method: "GET",
    onSuccess: cannedResponsesReceived.type,
    resolve: payload.resolve,
    reject: payload.reject
  });
};

export default slice.reducer;
